import styled from "styled-components";

const LanguageStyleWrapper = styled.div`
  .language-selector {
    position: relative;
    display: inline-block;
  }

  .language-button {
    background: transparent;
    border: 1px solid #ccc;
    color: #fff;
    font-size: 14px;
    border-radius: 6px;
    padding: 6px 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: background 0.2s ease;
  }

  .language-button:hover {
    background: #000;
  }

  .language-label {
    margin-left: 6px;
    white-space: nowrap;
  }

  .language-menu {
    position: absolute;
    top: 120%;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    padding: 6px 0;
    width: 180px;
    z-index: 1000;
    animation: fadeIn 0.15s ease;
  }

  .language-item {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 8px 12px;
    background: none;
    border: none;
    font-size: 14px;
    cursor: pointer;
    color: #333;
    transition: background 0.2s;
  }

  .language-item:hover {
    background-color: #f0f0f0;
  }

  .language-item.active {
    background-color: #e0e0e0;
    font-weight: 600;
  }

  .language-item img {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    margin-right: 8px;
    object-fit: cover;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export default LanguageStyleWrapper;
